import React from 'react';
import { getClassNames } from 'js/utils/classNames.util';

import style from './index.scss';

export const ProgressBar = ({ slidesCount, activeSlide, classNames }) => {
    const progress = `${(activeSlide + 1) * 100 / slidesCount}%`;

    return (
        <div className={getClassNames([style.progressBarContainer, classNames.progressBarContainer])} >
            <div className={getClassNames([style.progressBar, classNames.progressBar])} style={{ width: progress }} />
        </div>
    );
};

export default ProgressBar;
